"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedMessage = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../../hooks");
const FormattedMessage = (props) => {
    const Text = (0, hooks_1.useComponent)('Text');
    // eslint-disable-next-line react/prop-types
    const { children, component = Text } = props, rest = tslib_1.__rest(props, ["children", "component"]);
    const intl = (0, hooks_1.useIntl)();
    const Component = component;
    if (typeof children !== 'string' || !intl) {
        return react_1.default.createElement(Component, rest, children);
    }
    const { __ } = intl;
    return react_1.default.createElement(Component, rest, __(children));
};
exports.FormattedMessage = FormattedMessage;
